import {Settings} from '../Settings';
import {$window} from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * Base Element for Menus with Dropdowns
 */
export default class Menu extends HtmlElement {
  onReady() {
    this.subMenuLevels = this.getSubMenuLevels();
    this.positionSubMenus();
  }

  onResize() {
    this.positionSubMenus();
  }

  /**
   * Find all expandable sub Menu lists
   * @returns {array}
   */
  getSubMenuLevels() {
    return this.$element.find('ul ul');
  }

  /**
   * Position Menus to the left if they would flow out of the viewport to the right
   */
  positionSubMenus() {
    this.subMenuLevels.each((index) => {
      // remove positionLeft class so the calculation is not affected by it
      let $subMenuLevel = this.subMenuLevels.eq(index).removeClass(Settings.classPositionMenuLeft),
        $dropDownIcon = $subMenuLevel.prev('i'),
        positionMenuOnLeftSide = ($subMenuLevel.offset().left + $subMenuLevel.width() > $window.width());

      $subMenuLevel.toggleClass(Settings.classPositionMenuLeft, positionMenuOnLeftSide);

      if ($dropDownIcon.length) {
        $dropDownIcon.toggleClass($dropDownIcon.data('showlefticon'), positionMenuOnLeftSide);
        $dropDownIcon.toggleClass($dropDownIcon.data('showrighticon'), !positionMenuOnLeftSide);
      }
    });
  }
}
